
import { createContext } from "react";
import { AppContextInterface } from "./types";


const defaultContext = {
    confEnte: null,
    userLogged: false,
    tabMenuAutenticatoVisibile: true
};

export const AppCtx = createContext<AppContextInterface | null>(defaultContext);

export const AppCtxProvider = AppCtx.Provider
export const AppCtxConsumer = AppCtx.Consumer



